export default function numberToRating(number: number) {
  switch (number) {
    case 1:
      return 'VeryPoor'
    case 2:
      return 'Poor'
    case 3:
      return 'Average'
    case 4:
      return 'Good'
    case 5:
      return 'Excellent'
    default:
      return null
  }
}
